export const parseImgURL = (imgURL: string) => {
    if (!imgURL || imgURL === "")
        return process.env.REACT_APP_WL_TOKEN_IMG_URL;
  if (!imgURL.includes("ipfs://")) return imgURL;
  let output = imgURL.split("//")[1];
  output = "http://ipfs.io/ipfs/" + output;
  return output;
};
